import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-checked",
  "use": "icon-checked-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" fill=\"none\" viewBox=\"0 0 24 24\" id=\"icon-checked\"><defs><clipPath id=\"icon-checked_a\"><rect width=\"24\" height=\"24\" rx=\"0\" /></clipPath></defs><g style=\"mix-blend-mode:passthrough\" clip-path=\"url(#icon-checked_a)\"><rect x=\"5\" y=\"5\" width=\"14\" height=\"14\" rx=\"2\" fill=\"#276BEC\" /><path d=\"M16.208 9.207a.5.5 0 01-.004.708l-5.264 5.204a.021.021 0 01-.03 0l-2.698-2.668a.5.5 0 01.703-.711l1.998 1.975a.017.017 0 00.023 0L15.5 9.203a.5.5 0 01.708.004\" fill=\"#FFF\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol